module.exports = __webpack_public_path__ + "static/01-8efae752e7b80a2c5fc85a529ff46905.jpg";